import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  FaHome,
  FaChartLine,
  FaUser,
  FaInfoCircle,
  FaExchangeAlt,
  FaBalanceScale,
} from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { to: '/dashboard', icon: <FaHome />, label: 'Home' },
  { to: '/trading', icon: <FaChartLine />, label: 'Trade' },
  { to: '/exchange', icon: <FaExchangeAlt />, label: 'Swap' },
  { to: '/arbitrage', icon: <FaBalanceScale />, label: 'Arbitrage' },
  { to: '/profile', icon: <FaUser />, label: 'Profile' },
  { to: '/about', icon: <FaInfoCircle />, label: 'About' },
];

export default function GlassDockNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const handleNav = (e, to) => {
    if (!currentUser && to !== '/about') {
      e.preventDefault();
      navigate('/signin', { replace: true });
    }
  };

  return (
    <nav
      className="fixed bottom-4 left-4 right-4 z-50 h-16 rounded-card border border-stroke bg-surface/40 backdrop-blur-lg flex items-center justify-around" >
      {navItems.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          onClick={(e) => handleNav(e, item.to)}
          className={`flex flex-col items-center gap-1 text-sm transition-transform active:scale-95 ${
            location.pathname === item.to ? 'text-accent' : 'text-white/80'
          } ${!currentUser && item.to !== '/about' ? 'opacity-40 pointer-events-none' : ''}`}
        >
          <span className="text-xl stroke-2">{item.icon}</span>
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
